import { Box } from "@mui/material";
import React from "react";

interface AddNewItemButtonProps {
  handleClick?: () => void;
  disabled?: boolean;
  text: string;
}

export function AddNewItemButton({
  handleClick,
  disabled = false,
  text,
}: AddNewItemButtonProps) {
  return (
    <Box
      onMouseDown={(e) => {
        e.stopPropagation();
        disabled && e.preventDefault();
        if (!disabled && handleClick) {
          handleClick();
        }
      }}
      sx={{
        borderTop: "1px solid #eee",
        p: 1.5,
        textAlign: "center",
        color: disabled ? "text.disabled" : "primary.main",
        fontWeight: 500,
        cursor: disabled ? "not-allowed" : "pointer",
        backgroundColor: "background.paper",
        "&:hover": {
          backgroundColor: disabled ? "background.paper" : "action.hover",
        },
        opacity: disabled ? 0.5 : 1,
      }}
      onClick={() => {}}
    >
      {text}
    </Box>
  );
}
